import { defineStore } from 'pinia'
import actions from './actions.js';
import mutations from './mutations.js';
import getters from './getters.js';
import { cyoStore }  from '@/stores/cyo/cyo';

export function cyolistStore() {

  // const route = useRoute()
  // const key = 'route.meta.name'

  // console.log('acbd', )
  const router = useRouter() // Safe in setup stores (Nuxt 3)
  const route = useRoute()
  const cyo = cyoStore()
  let moduleType = route.meta?.moduleType
  let moduleSubType = route.meta?.moduleSubType

  let storeKey = `list-${moduleType}-${moduleSubType}-store`
  
  if(!moduleType || !moduleSubType) {
      storeKey = `list-${route?.name}-store`
  }

  return defineStore(storeKey,{

    state: () => {
      return {
        // setting, diamond
        skeleton:false,
        page:null,
        // ringm, earring, pendant
        moduleType: null, 
        moduleSubType: null, 
        filters : null,
        options: null,
        payload:null,
        filterTags:[],
        compare_list:[],
        compare_list_count:0,
        results:{
            data: Array.from({ length: 20 }, (v, i) => ({ id: 'empty_key_'+ i, key: 'empty_state' })),
            total:null,
            next_page_url:null,
            current_page:null,
        },
        error:null,
        showMoreSkeleton: false,
        currentController:null
      }
    },
    // could also be defined as
    // state: () => ({ count: 0 })
    getters: { ...getters},
    actions: {...actions, cyoStoreInstance: () => cyo, getRouterIns: () => router, commitMutation: function( mutationToCall, data ) {

      try {
        mutations[mutationToCall]( this, data )
        
      } catch (error) {

        console.error( 'CYO LIST MUTATION ERROR - ', this, mutationToCall, data, error )
        throw error
      }

    }},
  })()
}